<template>
  <section
    class="message-box"
    ref="message-box"
  >
    <img src="image/icon/icon-warning.svg">
    <div
      class="message"
      v-html="loadingDialogMessage"
    />
  </section>
</template>

<script>
import { computedGetters } from '@/utils/vuex-helper';
import { delay } from '@/utils/etc';
export default {
  name: 'FetchDataLoadingMessage',
  computed: {
    ...computedGetters(['loadingDialogVisible', 'loadingDialogMessage'])
  },
  watch: {
    async loadingDialogVisible(visible) {
      if (this.timerId) {
        clearTimeout(this.timerId);
      }
      const elDialog = document.getElementsByClassName(
        'el-dialog fifl-dialog right-fixed-dialog'
      )[0];
      if (visible) {
        if (elDialog) {
          elDialog.style.pointerEvents = 'none';
        }

        this.timerId = setTimeout(() => {
          this.isVisible = visible;
        }, 2500);
      } else {
        if (elDialog) {
          elDialog.style.pointerEvents = 'initial';
        }
        this.isVisible = visible;
      }
    },
    async isVisible(visible) {
      if (visible) {
        if (!this.$refs['message-box'].classList.contains('open')) {
          this.$refs['message-box'].style.display = 'flex';
          await delay(500);
          this.$refs['message-box'].style.zIndex = 9999999;
          this.$refs['message-box'].classList.add('open');
        }
      } else {
        if (this.$refs['message-box'].classList.contains('open')) {
          this.$refs['message-box'].classList.remove('open');
          await delay(500);
          this.$refs['message-box'].style.zIndex = 0;
          await delay(500);
          this.$refs['message-box'].style.display = 'none';
        }
      }
    }
  },
  data() {
    return {
      isVisible: false,
      timerId: null
    };
  }
};
</script>

<style lang='scss'>
.message-box {
  position: fixed;
  display: none;
  left: 50%;
  transform: translate(-50%, 0);
  width: 425px;
  height: 70px;
  background-color: #224ba2;
  border-radius: 11px;
  bottom: 20px;
  box-sizing: border-box;
  padding: 13px 25px;
  visibility: none;
  opacity: 0;
  transition: opacity 0.2s 0.2s, transform 0.2s 0.2s;

  &.open {
    visibility: visible;
    opacity: 1;
    display: flex;
    transform: translate(-50%, -10px);
  }

  img {
    width: 20px;
    height: 20px;
    margin: auto 0;
  }

  .message {
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.38;
    letter-spacing: -0.85px;
    text-align: center;
    color: #f0f0f0;
    margin: auto;
  }
}

@media screen and (max-width: 768px) {
  .message-box {
    max-width: 425px;
    height: 60px;
    width: calc(100% - 20px);
    bottom: 20px;
    img {
      width: 15px;
      height: 15px;
    }
    .message {
      font-size: 14px;
    }
  }
}
</style>
